
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 18c.253 0 .47-.063.65-.19.343-.233.948-.648 1.815-1.242s1.987-1.41 3.36-2.446 2.33-1.825 2.872-2.365C21.232 10.225 22 8.324 22 6.054c0-1.676-.587-3.104-1.761-4.284S17.638 0 15.959 0c-.994 0-1.93.225-2.805.676S11.56 1.748 11 2.54C9.772.847 8.128 0 6.069 0c-1.68 0-3.111.59-4.294 1.77S0 4.378 0 6.054c0 2.27.768 4.171 2.303 5.703.542.54 1.508 1.329 2.899 2.365s2.506 1.847 3.346 2.432c.84.586 1.45 1.005 1.829 1.257.18.126.388.189.623.189z"}})])
          )
        }
      }
    